import { Text, Primary13Regular, RedRed60 } from '@sequencehq/core-components'

import { useFeatureFlags } from 'hooks/useFeatureFlags'
import {
  CreditNoteRevenueRecognitionMethod,
  CreditNoteServicePeriod
} from 'CreditNotes/types'

/**
 * Inline per-line-item hints prompting the user to add a missing service period
 * or recognition method before issuing. Shared by the credit note detail table
 * and the issue-credit-note drawer so both surface validation identically.
 */
export const RevRecLineItemValidationHints = ({
  showHints,
  servicePeriod,
  revenueRecognitionMethod,
  onTriggerAdvancedEdit
}: {
  showHints: boolean
  servicePeriod?: CreditNoteServicePeriod
  revenueRecognitionMethod?: CreditNoteRevenueRecognitionMethod
  onTriggerAdvancedEdit: () => void
}) => {
  const flags = useFeatureFlags()

  if (!flags.useRevRec || !showHints) return null

  const missingServicePeriod = !servicePeriod
  const missingRecognitionMethod = !revenueRecognitionMethod

  if (!missingServicePeriod && !missingRecognitionMethod) return null

  return (
    <>
      {missingServicePeriod && (
        <MissingFieldHint
          label="Add service period"
          onClick={onTriggerAdvancedEdit}
          data-testid="creditNote.lineItem.missingServicePeriod"
        />
      )}
      {missingRecognitionMethod && (
        <MissingFieldHint
          label="Add recognition method"
          onClick={onTriggerAdvancedEdit}
          data-testid="creditNote.lineItem.missingRecognitionMethod"
        />
      )}
    </>
  )
}

const MissingFieldHint = ({
  label,
  onClick,
  'data-testid': dataTestId
}: {
  label: string
  onClick: () => void
  'data-testid'?: string
}) => (
  <Text
    {...Primary13Regular}
    color={RedRed60}
    display="block"
    cursor="pointer"
    onClick={onClick}
    data-testid={dataTestId}
  >
    {label}
  </Text>
)
